import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import { cleverTap } from "../../../services/provider/common";
import { CLEVER_TAP_EVENTS, rejectedReasons } from "../../../constants/provider/constant";
import { toast } from "react-toast";
import { updateRequests } from "../../centralOms/common/apiCalls";
import moment from "moment";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { logEventToAnalyticsPlatform } from "../../../helper/events";
import { EVENTS } from "../../centralOms/events_constant";

export default function ConfirmRejectAppointment({
  action,
  requestDetails,
  confirmRejectDialogVisible,
  setConfirmRejectDialogVisibility,
  fetchData,
  setFetchData,
}) {
  const [notes, setNotes] = useState("");
  const [homeVisitBy, setHomevistBy] = useState([
    { id: "HOME_VISIT_BY_DOCTOR", label: "Doctor", checked: false },
    { id: "HOME_VISIT_BY_LAB_TECHNICIAN", label: "LAB Technician", checked: false },
    { id: "HOME_VISIT_BY_ECG_TECHNICIAN", label: "ECG Technician", checked: false },
    { id: "HOME_VISIT_BY_MBBS_DOCTOR", label: "MBBS Doctor", checked: false },
    { id: "HOME_VISIT_BY_MD_DOCTOR", label: "MD Doctor", checked: false },
  ]);
  const [count, setCount] = useState(0);
  const [rejectOption, setRejectOption] = useState("");
  const isConfirmAction = action === "Confirm";


  useEffect(() => {
    if (isConfirmAction)
      cleverTap(CLEVER_TAP_EVENTS.confirmPopupShown, {
        RequestId: requestDetails.id,
        srcType: "web/mWeb",
        isPopupShown: 1,
      });
  }, []);

  const handleChange = (event, elem) => {
    let homeVisitByTemp = homeVisitBy;
    let count = 0;
    homeVisitByTemp = homeVisitByTemp.map((hvb) => {
      if (elem.id === hvb.id) {
        hvb.checked = event.target.checked;
      }
      hvb.checked === true ? count++ : (count += 0);
      return hvb;
    });
    setCount(count);
    setHomevistBy(homeVisitByTemp);
  };

  const HomeVisitMarkedBy = () => {
    let markedCases = [];
    homeVisitBy.forEach((element) => {
      if (element.checked) {
        markedCases.push(element.id);
      }
    });
    return markedCases;
  };

  const submitDetails = async () => {
    try {
      if (isConfirmAction) {
        cleverTap(CLEVER_TAP_EVENTS.confirmPopupBtnClick, {
          RequestId: requestDetails.id,
          srcType: "web/mWeb",
          srcPage: "appointments",
          statusInfo: "New Appointment/ Rescheduled by Ops",
          visitType: requestDetails.visitType,
          testCategory: requestDetails.packageName,
          HomevisitBy: HomeVisitMarkedBy(),
          Remarks: notes,
        });
      }

      let remarks = isConfirmAction || rejectOption == "Others" ? notes : rejectOption;
      setConfirmRejectDialogVisibility(false);
      let response = await updateRequests(["LABS"], [requestDetails.id], remarks, action);
      if (response?.success) {
        cleverTap(isConfirmAction ? CLEVER_TAP_EVENTS.confirmedApptSuccess : CLEVER_TAP_EVENTS.rejectApptSuccess, {
          RequestId: requestDetails.id,
          srcType: "web",
          HomevisitBy: HomeVisitMarkedBy(),
          Remarks: isConfirmAction || rejectOption == "Others" ? notes : rejectOption,
          srcPage: "appointments",
          isSuccess: 1,
        });
        setFetchData(!fetchData);
        toast.success("Request updated successfully");
        logEventToAnalyticsPlatform({
          name: EVENTS.PC_LS_ACTION.name,
          payload: {
            tab_name: EVENTS.TAB_NAME_UPCOMING_APPOINTMENTS,
            filterValue: 'true',
            reference_id: '' + requestDetails.PMEntityId,
            reference_provider_id: '' + requestDetails.currentProvider,
            service_name: EVENTS.SERVICE_NAME_LABS,
            action: isConfirmAction ? EVENTS.ACTION.CONFIRM_APPOINTMENT_CLICKED : EVENTS.ACTION.REJECT_APPOINTMENT_CLICKED,
          },
          schema: EVENTS.PC_LS_ACTION.schema,
        })
      } else {
        if (isConfirmAction)
          cleverTap(CLEVER_TAP_EVENTS.confirmedApptFailed, {
            RequestId: requestDetails.id,
            srcType: "web",
            srcPage: "appointments",
            isSuccess: 0,
            failureReason: "Error 404",
          });
        toast.error(`Request update failed - ${response?.error}`);
      }
    } catch (err) {
      toast.error(`Request update failed - ${err?.response?.data?.error}`);
    }
  };

  const closePopUp = () => {
    setConfirmRejectDialogVisibility(false);
  };

  return (
    <Dialog
      open={confirmRejectDialogVisible}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          closePopUp();
        } else return false;
      }}
      fullWidth={true}
      maxWidth={"sm"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">{!isConfirmAction ? "Reject Appointment" : "Confirm Appointment"}</span>
            <div className="text-xs text-gray-500">
              Request ID <span className="font-semibold">{requestDetails.id} </span>
            </div>
          </div>
          <div className="text-gray-500" onClick={closePopUp}>
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box component="form" noValidate autoComplete="off" onSubmit={(event) => submitDetails(event)}>
          <div className="pb-5">
            <div>
              <span className="text-gray-600 text-sm"> Appointment Date and Time : </span>
              <span className="text-gray-600 font-semibold text-sm">{moment(requestDetails.fulfillmentDate).format("MMMM Do YYYY hh:mm A")}</span>
            </div>
          </div>

          {requestDetails.visitType === "Home_Visit" && isConfirmAction ? (
            <div>
              <div className="pb-5">
                <span className="text-gray-600 text-sm">
                  Home Visit By <span className="text-red-500 font-semibold"> * </span> :
                </span>
                <div className="flex flex-wrap justify-start text-xs">
                  {homeVisitBy && homeVisitBy.length > 0 ? (
                    homeVisitBy.map((elem, i) => (
                      <FormControlLabel
                        key={i}
                        sx={{ "& .MuiFormControlLabel-label": { fontSize: 14 } }}
                        label={elem.label}
                        control={<Checkbox size="small" checked={elem.checked} onChange={(event) => handleChange(event, elem)} />}
                      />
                    ))
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}

          {!isConfirmAction && (
            <div>
              <div className="pb-5">
                <FormControl className="w-full">
                  <InputLabel id="rejectOption">Reject Option</InputLabel>
                  <Select
                    labelId="rejectOption"
                    name="rejectOption"
                    id="rejectOption"
                    value={rejectOption}
                    label="Reject Option"
                    onChange={(event) => {
                      setRejectOption(event.target.value);
                    }}
                    required
                  >
                    {rejectedReasons.map((ele) => (
                      <MenuItem value={ele}>{ele}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
              {rejectOption === "Others" ? (
                <div className="pb-10">
                  <FormControl className="w-full">
                    <TextField
                      sx={{ "& .MuiOutlinedInput-input, .MuiInputLabel-root": { fontSize: 14 } }}
                      id="outlined-multiline-static-reject-option"
                      label="Reason For Rejection*"
                      placeholder="Please Write reason for rejection."
                      name="reasonRejected"
                      onChange={(event) => setNotes(event.target.value)}
                      value={notes}
                    />
                  </FormControl>
                </div>
              ) : null}
            </div>
          )}

          {isConfirmAction ? (
            <div className="pb-10">
              <FormControl className="w-full">
                <TextField
                  sx={{ "& .MuiOutlinedInput-input, .MuiInputLabel-root": { fontSize: 14 } }}
                  id="outlined-multiline-static"
                  label="Remarks*"
                  multiline
                  name="notes"
                  onChange={(event) => setNotes(event.target.value)}
                  rows={4}
                  value={notes}
                />
              </FormControl>
            </div>
          ) : null}

          <div className="pb-5 flex justify-between text-center">
            <div
              className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold"
              type="submit"
              variant="contained"
              size="large"
              onClick={closePopUp}
            >
              <span>Cancel</span>
            </div>
            <div
              className={
                ((requestDetails.visitType !== "Home_Visit" || count > 0) && notes) ||
                (!isConfirmAction && ((rejectOption !== "" && rejectOption !== "Others") || (rejectOption === "Others" && notes)))
                  ? "border-green-600 bg-green-600 border cursor-pointer  text-gray-100 rounded-md w-40 p-1 text-sm font-semibold"
                  : "border-green-200 bg-green-200 border  text-black-300 rounded-md w-40 p-1 text-sm font-semibold"
              }
              type="submit"
              variant="contained"
              size="large"
              onClick={
                ((requestDetails.visitType !== "Home_Visit" || count > 0) && notes) ||
                (!isConfirmAction && ((rejectOption !== "" && rejectOption !== "Others") || (rejectOption === "Others" && notes)))
                  ? submitDetails
                  : null
              }
            >
              <span>{action}</span>
            </div>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
